var _circle, _circle2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHospitalOnboarding(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23,
    stroke: "#322F61",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#322F61"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_68_42302)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_68_42302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.667 18.9998H27.3337V17.3332C27.3337 16.4165 26.5837 15.6665 25.667 15.6665H22.3337C21.417 15.6665 20.667 16.4165 20.667 17.3332V18.9998H17.3337C16.417 18.9998 15.667 19.7498 15.667 20.6665V30.6665C15.667 31.5832 16.417 32.3332 17.3337 32.3332H30.667C31.5837 32.3332 32.3337 31.5832 32.3337 30.6665V20.6665C32.3337 19.7498 31.5837 18.9998 30.667 18.9998ZM22.3337 17.3332H25.667V18.9998H22.3337V17.3332ZM30.667 30.6665H17.3337V20.6665H30.667V30.6665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8337 22.3332H23.167V24.8332H20.667V26.4999H23.167V28.9999H24.8337V26.4999H27.3337V24.8332H24.8337V22.3332Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_68_42302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(14 14)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_68_42302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalOnboarding);
export default __webpack_public_path__ + "static/media/hospital-onboarding.a1283f567eaa6c7f604262209c421b2f.svg";
export { ForwardRef as ReactComponent };